import React from "react";
import { AlertCircle, CheckCircle2 } from "lucide-react";

import { Badge } from "@/components/ui/Badge";

// The outcome of one migration attempt, as recorded in tenant_db_migrations.
// "skipped" counts as done: the migration had nothing to do, which is a good
// outcome, not a half-finished one.
//
// colorIndex values come from BADGE_COLORS in components/ui/Badge.jsx.
const STATUS_TONE = { succeeded: 3, skipped: 8, started: 2, failed: 1 };

const StatusPill = ({ status }) => {
    const done = status === "succeeded" || status === "skipped";
    return (
        <Badge
            variant="solid"
            colorIndex={STATUS_TONE[status] ?? 8}
            icon={done ? <CheckCircle2 size={10} /> : <AlertCircle size={10} />}
            label={status || "unknown"}
            className="rounded-full shrink-0 mt-1"
            badgeStyle="px-2 py-0.5 text-[10px] font-medium"
        />
    );
};

export default StatusPill;
